import { Container, Row } from "react-bootstrap";
import './StudyOneInstruction.css'

export default function StudyOneInstructionPageOne(){
    return (
        <Container className="study-item">
            <Row >
                <h1 style={{ fontWeight: 'bold'}}>What's Emotion AI?</h1>
                <br /><br /><br />
                <Container style={{width:'90%'}}>
                    <p>Some scientists believe that people express their emotions through facial expressions, and therefore, 
                        it is possible to infer their emotions by analyzing facial expressions.</p>
                    <p>Based on this perspective, computer scientists have developed artificial intelligence systems that infer people’s emotions by 
                        capturing their facial expressions. We refer to these systems as <strong className="highlight">facial expression-based Emotion AI (FEAI)</strong>.</p>

                </Container>

            </Row>
        </Container>
    );
};